import axios from "axios";
import moment from "moment";

export default {
  methods: {
    getCardFlag: function (cardnumber) {
      cardnumber = cardnumber.replace(/[^0-9]+/g, "");

      var cards = {
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mastercard:
          /^(5[1-5][0-9]{14}|2(2[2-9][0-9]{13}|[3-6][0-9]{14}|7[01][0-9]{13}|720[0-9]{12})|2500[0-9]{12}|2340[0-9]{12}|2238[0-9]{12})$/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        american: /^3[47][0-9]{13}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        hipercard: /^(606282\d{10}(\d{3})?|3841\d{15})$/,
        elo: /^(4011|4312|4389|4514|4576|5041|5066|5067|5090|6277|6362|6363|6504|6505|6506|6507|6509|6516|6550)\d+$/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
        aura: /^(5078\d{2})(\d{2})(\d{11})$/,
      };

      for (var flag in cards) {
        if (cards[flag].test(cardnumber)) {
          return flag;
        }
      }

      return "";
    },
    async getTipoPessoa() {
      const { data } = await this.$http.post("/sistema/tipo/pessoa");
      return data;
    },
    async getTipoEndereco() {
      const { data } = await this.$http.post("/sistema/tipo/endereco");
      return data;
    },
    async getTipoFone() {
      const { data } = await this.$http.post("/sistema/tipo/fone");
      return data;
    },
    async getTipoEmail() {
      const { data } = await this.$http.post("/sistema/tipo/email");
      return data;
    },
    async getUnidadeMedidas() {
      const { data } = await this.$http.get(
        "/produto/unidade-medidas?per_page=150",
      );
      return data.data;
    },
    async getGrupos() {
      const { data } = await this.$http.get("/grupos?per_page=150");
      return data.data;
    },
    async getRecorrencia() {
      const { data } = await this.$http.get(
        "/produto/recorrencia?per_page=150",
      );
      return data.data;
    },
    async getCidade(filtro) {
      const { data } = await this.$http.post("/sistema/cidade", {
        filtro,
      });
      return data;
    },
    async getCep(cep) {
      const { data } = await axios.post(
        "http://clippservice.com.br/api/correios/cep/consulta",
        {
          cep,
        },
        {
          headers: {
            Accept: "application/json",
          },
        },
      );
      return data.status ? data.data : [];
    },
    numberToReal(valor, casas = 2) {
      var positivo = true;
      var sifrao = false;

      if (valor) {
        if (valor < 0) {
          positivo = false;
          valor = valor * -1;
        }

        var numero = parseFloat(valor);
        numero = numero.toFixed(casas).split(".");

        if (sifrao) {
          numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
        } else {
          numero[0] = numero[0].split(/(?=(?:...)*$)/).join(".");
        }

        if (positivo == false) {
          return "-" + numero.join(",");
        }

        return numero.join(",");
      }

      return "0,00";
    },
    formatDate(value, fmt = "DD/MM/YYYY ") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
  },
};
